// @ts-nocheck: converted from JS

import Recaging from '@/components/Studies/Recaging';

export default Recaging;
